import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SKIP_ERROR_TOAST } from '@core/http/http-context.tokens';
import { ToasterService } from '@core/services/toaster.service';
import {
  HTTP_ERROR_FALLBACKS,
  HTTP_ERROR_I18N_KEYS,
  resolveHttpErrorMessage,
  shouldShowGlobalErrorToast,
} from '@core/utils/http-error.util';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toaster = inject(ToasterService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        toaster.showError(HTTP_ERROR_FALLBACKS[HTTP_ERROR_I18N_KEYS.generic]);
        return throwError(() => error);
      }

      const skipToast = req.context.get(SKIP_ERROR_TOAST);
      if (shouldShowGlobalErrorToast(error, { skipToast, url: req.url })) {
        toaster.showError(resolveHttpErrorMessage(error));
      }

      return throwError(() => error);
    }),
  );
};
